// extracted by mini-css-extract-plugin
export default {"versionWrapper":"VersionSelect_versionWrapper__bNQET","label":"VersionSelect_label__GK+9Q","patch":"VersionSelect_patch__YkvRR"};